import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-read-more',
  templateUrl: './read-more.component.html',
  styleUrls: ['./read-more.component.css'],
})
export class ReadMoreComponent implements OnInit {
  @Input() text: string;
  @Input() maxLengthToShow: number;
  isCollapsed: boolean = true;

  constructor() {}

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }
  ngOnInit() {}
}
